import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styled, { ThemeContext } from 'styled-components/macro'
import { Helmet } from 'react-helmet'
import { css } from 'styled-components'

import { AppThemes } from 'config/enums'

import { media } from 'utilities/styled'
import { getAppTheme } from 'utilities/utils'

import Link from 'components/atoms/link'
import FramedImage from 'components/atoms/framed-image'
import AuthFooter from 'components/molecules/auth-footer'
import PayoffPoster from 'components/molecules/payoff-poster'

const Container = styled.div`
  ${media.desktop`
    display: flex;
    height: 100vh;
  `}
`

const Aside = styled.aside`
  display: none;

  ${media.desktop`
    display: flex;
    flex: 1 1 auto;
  `}
`

const Main = styled.main`
  background-color: ${({ theme }) => theme.colors.brandFoxtrot};
  min-height: 100vh;

  ${media.desktop`
    display: flex;
    flex: 0 0 ${({ theme }) => theme.sizeByFactor(80)};
    flex-direction: column;
    overflow: scroll;
    padding: ${({ theme }) => theme.sizings.lvl3} ${({ theme }) => theme.sizeByFactor(15)} ${({ theme }) => theme.sizings.lvl1};
  `}
`

const Header = styled.header`
  padding: ${({ theme }) => theme.sizings.lvl2};
  text-align: center;

  ${media.desktop`
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
    text-align: left;
  `}
`

const Footer = styled(AuthFooter)`
  margin-top: auto;
  padding: ${({ theme }) => theme.sizings.lvl5};
  text-align: center;

  ${media.desktop`
    padding: ${({ theme }) => theme.sizings.lvl3} 0 0;
    text-align: left;
  `}
`

const SharedAppLogoStyles = css`
  width: 75%;
  margin: auto;
  display: block;
  text-align: center;
  margin-top: ${({ theme }) => theme.sizeByFactor(2.5)};
  margin-bottom: ${({ theme }) => theme.sizings.lvl5};
`

const Logo = styled(FramedImage)`
  ${SharedAppLogoStyles}
`

const CaAutoFinanceLogo = styled(FramedImage)`
  ${SharedAppLogoStyles}
  max-width: ${({ theme }) => theme.sizeByFactor(19.1)};
`

function AuthLayout({ children, pageTitle }) {
  const { t } = useTranslation()
  const { themeName } = getAppTheme()
  const theme = useContext(ThemeContext)

  const { themeNameCamelCase } = getAppTheme()

  return (
    <Container>
      <Helmet
        title={`${pageTitle} - ${t(`themeOptions.${themeNameCamelCase}.productName`)}`}
      />
      <Aside>
        <PayoffPoster />
      </Aside>
      <Main>
        <Header>
          <Link to="/">
            {themeName === AppThemes.CA_AUTO_FINANCE ? (
              <CaAutoFinanceLogo src={theme.logo} alt="CA Auto Finance Logo" />
            ) : (
              <Logo src={theme.logo} alt="logo" />
            )}
          </Link>
        </Header>
        {children}
        <Footer />
      </Main>
    </Container>
  )
}

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
  pageTitle: PropTypes.string.isRequired,
}

export default AuthLayout
